import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import User from '../../../../../Model/User';
import UserExerciseOverrides, { UserExerciseOverrideSource } from '../../../../../Model/UserExerciseOverrides';
import LoadingPage from '../../../../../components/LoadingPage';
import ReplacementRow from './ReplacementRow';
import { List, EmptyState } from './styles';
import texts from './texts.json';

const ExerciseReplacements = ({ userDoc }) => {
  const overridesDoc = useMemo(
    () => new UserExerciseOverrides(userDoc.id),
    [userDoc.id],
  );

  if (!overridesDoc.isLoaded) {
    return <LoadingPage />;
  }

  // Client-applied replacements are intentionally hidden — ACs only manage AC-sourced overrides.
  // Sorted by `date` desc so the most recently changed replacement is on top.
  const entries = overridesDoc.activeEntries
    .filter((entry) => entry.source === UserExerciseOverrideSource.AC)
    .sort((a, b) => (b.date?.toMillis?.() ?? 0) - (a.date?.toMillis?.() ?? 0));

  if (entries.length === 0) {
    return <EmptyState>{texts.emptyOverrides}</EmptyState>;
  }

  return (
    <List>
      {entries.map((entry) => (
        <ReplacementRow
          key={entry.originalExerciseId}
          userId={userDoc.id}
          originalExerciseId={entry.originalExerciseId}
          entry={entry}
        />
      ))}
    </List>
  );
};

ExerciseReplacements.propTypes = {
  userDoc: PropTypes.instanceOf(User).isRequired,
};

export default observer(ExerciseReplacements);
